export const morningBriefingTitle = "yo30Qd";
export const morningBriefingDescription = "essB9b";
export const eveningBriefingTitle = "_UsLvb";
export const eveningBriefingDescription = "ARQCje";
export const inboxBriefingMorningCommandText = "A8wpvb";
export const inboxBriefingEveningCommandText = "sYBY$b";
export default {morningBriefingTitle,morningBriefingDescription,eveningBriefingTitle,eveningBriefingDescription,inboxBriefingMorningCommandText,inboxBriefingEveningCommandText};